module.exports = __webpack_public_path__ + "static/media/LK_Event.2546b937.svg";